/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Success_Create2Inputs */

const en_coinvestments_report_snapshotform_success_create2 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Success_Create2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry added`)
};

/**
* | output |
* | --- |
* | "Entry added" |
*
* @param {Coinvestments_Report_Snapshotform_Success_Create2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_success_create2 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Success_Create2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Success_Create2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_success_create2(inputs)
});
export { coinvestments_report_snapshotform_success_create2 as "coInvestments_report_snapshotForm_success_create" }